{
  "version": 1,
  "asset_id": "941ae1f3-4bd8-4772-b693-cc9db6868f7a",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/941ae1f3-4bd8-4772-b693-cc9db6868f7a/carage-semrush-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/941ae1f3-4bd8-4772-b693-cc9db6868f7a/carage-semrush-1280.webp",
  "original_filename": "carage-semrush-1280.webp",
  "size": 39490,
  "content_type": "image/webp",
  "created_at": "2026-08-02T02:38:52Z"
}
